import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(theme => ({
  root: {
    width: '100%',
    padding: 10
  },
  header: {
    display: '-webkit-box'
  },
  title: {
    color: '#341b6c',
    fontWeight: 'bold',
    letterSpacing: '0.13px',
    textAlign: 'center',
    margin: '0 10px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '24px',
      letterSpacing: '0.065px',
      lineHeight: '40px'
    }
  },
  content: {
    color: '#341b6c',
    letterSpacing: '0.13px',
    textAlign: 'center',
    wordWrap: 'normal',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
      letterSpacing: '0.065px'
    }
  },
  smallContent: {
    fontSize: '14px',
    margin: '30px 0'
  },
  normalContent: {
    fontSize: '20px',
    margin: '50px 0'
  },
  bigContent: {
    fontSize: '28px',
    margin: '62px 0'
  },
  warningIcon: {
    color: '#451295',
    fontSize: '40px'
  },
  warningIconBig: {
    fontSize: '80px'
  },
  row: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'center',
    justifyContent: 'center'
  },
  column: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  }
}))
